import React from 'react';
// import {useTranslation} from "react-i18next";
import {Box} from "@material-ui/core";
// import {makeStyles} from "@material-ui/core/styles";
// import {useLocation} from "react-use";
// import {Route, Switch, useRouteMatch} from "react-router-dom";
// import {Helmet} from "react-helmet";

import AdminUserTable from "../Component/User/AdminUserTable";
// import AppColor from "../../../utilities/AppColor";
// import UserForm from "../../Client/User/Components/UserForm";


// const useStyles = makeStyles((theme) => ({
//     title: {
//         color: AppColor.orange,
//         fontSize: 32,
//         fontWeight: '600'
//     },
//     box: {
//         border: '1px solid rgba(0, 0, 0, 0.27)',
//         borderRadius: '10px'
//     }
// }));

const AdminUserManagement = () => {
    return (
        <Box>
            <AdminUserTable/>
        </Box>
    )
}

export default AdminUserManagement;
